module.exports = __webpack_public_path__ + "static/media/play-fill.76c67511.svg";